import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-modal-id"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    id: "modal-popup",
    class: _normalizeClass(["flex", [$options.modalType, $data.modalMobileType, $props.parentStyle]]),
    "data-modal-id": $props.modalId
  }, [
    _createElementVNode("div", {
      id: "modal-popup__content",
      class: _normalizeClass(_ctx.$attrs.class),
      style: _normalizeStyle(_ctx.$attrs.style)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 6)
  ], 10, _hoisted_1))
}